
import installer from './defaults'

export * from './components' // 公开单个组件的使用
export * from './constants'  // 公开常量定义
export * from './utils'      // 公开方法

export const install = installer.install 
export const version = installer.version

export default installer
